<template>
  <div class="copy-field" :class="{ 'copy-field--block': block }">
    <pre class="copy-field__value">{{ value }}</pre>
    <button type="button" class="copy-field__btn" :aria-label="'Copy ' + (label || 'value')" @click="copy">
      <i :class="copied ? 'el-icon-check' : 'el-icon-document-copy'"></i>
      <span>{{ copied ? "Copied" : "Copy" }}</span>
    </button>
  </div>
</template>

<script>
  // 等宽文本 + 复制按钮（MCP 地址、命令、密钥、示例代码共用）
  export default {
    name: "CopyField",
    props: {
      value: { type: String, default: "" },
      label: { type: String, default: "" },
      // 多行代码块样式
      block: { type: Boolean, default: false }
    },
    data() {
      return { copied: false, timer: null };
    },
    beforeDestroy() {
      clearTimeout(this.timer);
    },
    methods: {
      copy() {
        const done = () => {
          this.copied = true;
          clearTimeout(this.timer);
          this.timer = setTimeout(() => (this.copied = false), 1600);
        };
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(this.value).then(done, () => {
            this.$clipboard(this.value);
            done();
          });
        } else {
          this.$clipboard(this.value);
          done();
        }
      }
    }
  };
</script>

<style scoped lang="scss">
  .copy-field {
    display: flex;
    align-items: center;
    gap: 8px;
    background: var(--vtm-well);
    border: 1px solid var(--vtm-line);
    border-radius: var(--vtm-r-md);
    padding: 10px 10px 10px 14px;
    min-width: 0;

    &--block {
      align-items: flex-start;
    }

    &__value {
      flex: 1;
      min-width: 0;
      margin: 0;
      font-family: var(--vtm-mono);
      font-size: 13px;
      line-height: 1.6;
      color: var(--vtm-ink);
      white-space: pre-wrap;
      word-break: break-all;
    }

    &--block &__value {
      white-space: pre;
      overflow-x: auto;
      word-break: normal;
    }

    &__btn {
      flex-shrink: 0;
      display: inline-flex;
      align-items: center;
      gap: 5px;
      border: 1px solid var(--vtm-line-2);
      background: var(--vtm-surface);
      color: var(--vtm-ink-2);
      border-radius: var(--vtm-r-sm);
      padding: 4px 9px;
      font-size: 12px;
      font-weight: 600;
      cursor: pointer;
      transition: color var(--vtm-speed), border-color var(--vtm-speed);

      &:hover {
        color: var(--vtm-mint-ink);
        border-color: var(--vtm-mint-dim);
      }

      &:focus-visible {
        outline: none;
        box-shadow: var(--vtm-focus-ring);
      }
    }
  }
</style>
